import React, { useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import { FormControl } from "@mui/material";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useEditAdminMailMutation } from "../../api/admin/adminAccount";
import { useEditUserMailMutation } from "../../api/user/userAccount";
import { isEmailValid } from "../../../utils/functions/form";
import { actions as appActions } from "../../../app/appSlice";
import { ROLE } from "../../../utils/constants/profiles";
import { t } from "i18next";

const EditMailPage = ({ cardElement }) => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.app.role);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const [formData, setFormData] = useState({
    newMail: "",
  });

  const [validationErrors, setValidationErrors] = useState({
    newMail: "",
  });
  const [editAdminMail] = useEditAdminMailMutation();
  const [editUserMail] = useEditUserMailMutation();

  const handleInputChange = (e) => {
    setValidationErrors({});
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsEditLoading(true);
    const errors = {};
    if (!formData.newMail) errors.newMail = t("FieldRequired");
    if (!isEmailValid(formData.newMail)) errors.newMail = t("InsertValidMail");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setIsEditLoading(false);
      return;
    }
    setValidationErrors({});
    const mailData = {
      NewMail: formData.newMail,
    };
    (role === ROLE.USER ? editUserMail(mailData) : editAdminMail(mailData))
      .then((res) => {
        if (res?.data?.Result !== 1) {
          toast.error(t("EmailAlreadyUsedOrWrongPass"));
          setIsEditLoading(false);
          return;
        }

        if (role !== ROLE.USER) {
          toast.success(t("EmailUpdated"));
          dispatch(appActions.updateEmail(mailData.NewMail));
        } else {
          toast.success(t("CheckEmailToConfirm"));
        }

        setFormData({
          newMail: "",
        });

        setIsEditLoading(false);
        if (role !== ROLE.USER) {
          setTimeout(() => {
            window.location.reload();
          }, 750);
        }
      })
      .catch(() => {
        toast.info(t("ReqErr"));
        setIsEditLoading(false);
      });
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        {!cardElement && <h2>{t("EditMail")}</h2>}
        {formData.newMail && (
          <p className="font-semibold text-red-600 mx-2">
            {t("ChangeMailWarning")}
          </p>
        )}
        <FormControl
          sx={{ width: "80%" }}
          onSubmit={handleSubmit}
          className={`flex flex-col ${cardElement ? "" : "mt-6"}`}
        >
          <CoreInputField
            sx={{ marginTop: cardElement ? "5px" : "30px" }}
            label={t("NewMail")}
            type="email"
            name="newMail"
            value={formData.newMail}
            onChange={handleInputChange}
            required={true}
            error={Boolean(validationErrors.newMail)}
            helperText={validationErrors.newMail}
          />

          <div
            className={`flex justify-around ${cardElement ? "mt-5" : "mt-12"}`}
          >
            <CoreButton
              disabled={isEditLoading}
              sx={{ width: "150px", textAlign: "center" }}
              className={"btn-round"}
              variant="contained"
              testo={isEditLoading ? t("Wait") : t("Edit")}
              onClick={handleSubmit}
            />
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default EditMailPage;
